import React from 'react';
import { Container, Header } from 'features/shared/ui/Page';
import Spacer from 'features/shared/Spacer';
import Table from './table';
import Statistics from './statistics';

import Services from './services';
import { GeneralStatistics } from 'features/schools/GeneralStatistics';
import Banners from '../shared/Banners/Banners';
import { useBannersContext } from '../shared/Banners/BannersContext';
import useUserData from 'hooks/useUserData';

const Component = () => {
  const { banners } = useBannersContext({ section: 'main' });
  const userData = useUserData();
  const isRegion = userData?.isRegion || userData?.isLargeCity || false;
  return (
    <Container>
      <Header>Школы</Header>
      <Spacer size={40} />
      <GeneralStatistics />
      <Spacer size={48} />
      <Statistics isRegion={isRegion} />
      <Spacer size={48} />
      <Services isRegion={isRegion} />
      <Spacer size={48} />
      <Table isRegion={isRegion} abTest={userData?.abTestMark === 'school_involvement_test'} />
    </Container>
  );
};

export default Component;
